export const getErrorMessage = (e: unknown) => {
  if (e instanceof Error) return e.message;

  if (e && typeof e === 'object' && 'error' in e && typeof e.error === 'string') return e.error; // apple sends error code in this format

  return String(e);
};
